import React from 'react';

const TextArea = () => {
  return (
    <div
      className='w-full max-w-[700px] rounded-lg border-2 border-[#173058] 
    has-[textarea:placeholder-shown]:border-[#17305866] !has-[textarea:focus]:border-l-primary
   '
    >
      <textarea
        placeholder='textarea What type of legal issue are you facing?'
        className='w-full h-full bg-transparent outline-none resize-none px-6 py-3'
        rows={6}
      ></textarea>
    </div>
  );
};

export default TextArea;
